import React from "react";
import Header8 from "./../Common/Header8";
import Footer from "./../Common/Footer";
import Banner from "./../Elements/Banner";
import Projects3 from "./../Elements/Projects3";
import Projects4 from "../Elements/Projects4";
import SimilarProjects from "./../Elements/SimilarProjects";

var bnrimg = require("../../images/banner/banner.jpg")


class ProjectCorousel extends React.Component {
  render() {
    return (
      <>
        <Header8 />
        <div className="page-content">
          <Banner title="Nos Projets" pagename="Nos Projets" bgimage={bnrimg} />

          <Projects3
            alignment="separator-left"
            title="Nos Projets"
            // bgcolor="bg-gray"
          />
          {/* <Projects3
            alignment="separator-left"
            title="Carousel style 1"
            bgcolor="bg-gray"
          />
          <Projects4 /> */}
          {/* <SimilarProjects
            alignment="separator-left"
            title="Nos Projets"
          /> */}
        </div>

        <Footer />
      </>
    );
  }
}

export default ProjectCorousel;
